"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _popover = _interopRequireDefault(require("@paprika/popover"));

var _dateInput = _interopRequireDefault(require("@paprika/date-input"));

var _SingleDateCalendar = _interopRequireDefault(require("@paprika/calendar/lib/SingleDateCalendar"));

var _useDebounce = _interopRequireDefault(require("@paprika/helpers/lib/hooks/useDebounce"));

var _isElementContainsFocus = _interopRequireDefault(require("@paprika/helpers/lib/dom/isElementContainsFocus"));

var _extractChildrenProps = _interopRequireDefault(require("@paprika/helpers/lib/extractChildrenProps"));

var _DateInputPropsCollector = _interopRequireDefault(require("./components/DateInputPropsCollector"));

var _DatePickerPopoverPropsCollector = _interopRequireDefault(require("./components/DatePickerPopoverPropsCollector"));

var sc = _interopRequireWildcard(require("./DatePicker.styles"));

var propTypes = {
  children: _propTypes["default"].node,

  /** Date format used while entering and parsing user input. */
  dateFormat: _propTypes["default"].string,

  /** Selected date in moment object. */
  date: _propTypes["default"].instanceOf(_moment["default"]),

  /** Date format used while displaying date. It should be human-friendly and spelled out, default is MMMM DD,YYYY */
  humanFormat: _propTypes["default"].string,

  /** ID for the `<input>`. */
  id: _propTypes["default"].string,

  /** Should be disabled or not, default is false. */
  isDisabled: _propTypes["default"].bool,

  /** Should be read-only or not, default is false. */
  isReadOnly: _propTypes["default"].bool,

  /** Callback when date is selected or input. */
  onChange: _propTypes["default"].func.isRequired,

  /** Internal errors callback */
  onError: _propTypes["default"].func,

  /** If there is an external error or not. */
  hasError: _propTypes["default"].bool
};
var defaultProps = {
  children: null,
  dateFormat: "MM/DD/YYYY",
  date: null,
  hasError: false,
  humanFormat: undefined,
  id: null,
  isDisabled: false,
  isReadOnly: false,
  onError: function onError() {}
};

function DatePicker(props) {
  // Props
  var children = props.children,
      dateFormat = props.dateFormat,
      date = props.date,
      humanFormat = props.humanFormat,
      id = props.id,
      isDisabled = props.isDisabled,
      isReadOnly = props.isReadOnly,
      onChange = props.onChange,
      onError = props.onError,
      hasError = props.hasError; // State

  var _React$useState = _react["default"].useState(null),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      possibleDate = _React$useState2[0],
      setPossibleDate = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(false),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      shouldShowCalendar = _React$useState4[0],
      setShouldShowCalendar = _React$useState4[1]; // Ref


  var calendarRef = _react["default"].useRef(null);

  var inputRef = _react["default"].useRef(null);

  var debouncedPossibleDate = (0, _useDebounce["default"])(possibleDate, 300);
  var extendedInputProps = (0, _extractChildrenProps["default"])(children, _DateInputPropsCollector["default"]);
  var extendedPopoverProps = (0, _extractChildrenProps["default"])(children, _DatePickerPopoverPropsCollector["default"]);

  function hideCalendar() {
    if (shouldShowCalendar) setShouldShowCalendar(false);
    if (inputRef.current) inputRef.current.blur();
  }

  function showCalendar() {
    if (!shouldShowCalendar) setShouldShowCalendar(true);
  }

  function handleChange(newDate) {
    if (date !== newDate) onChange(newDate);
  }

  function handleClosePopover() {
    if (!(0, _isElementContainsFocus["default"])(calendarRef.current) && !(0, _isElementContainsFocus["default"])(inputRef.current)) {
      hideCalendar();
    }
  }

  function handleKeyUpOnEscape(event) {
    if (event.key === "Escape") {
      hideCalendar();
    }
  }

  function handleResetPossibleDate() {
    setPossibleDate(null);
  }

  function handleSelect(selectedDate) {
    hideCalendar();
    window.requestAnimationFrame(function () {
      handleChange(selectedDate);
    });
  }

  function handlePossibleDateChange(newPossibleDate) {
    if (newPossibleDate.isSame(possibleDate, "year") && newPossibleDate.isSame(possibleDate, "month")) return;
    setPossibleDate(newPossibleDate);
  }

  var hasInputError = extendedInputProps && extendedInputProps.hasError;
  var hasErrorValue = hasError || hasInputError;
  return /*#__PURE__*/_react["default"].createElement(_popover["default"], (0, _extends2["default"])({
    offset: 8
  }, extendedPopoverProps, {
    isOpen: shouldShowCalendar,
    onClose: handleClosePopover,
    onKeyUp: handleKeyUpOnEscape,
    shouldKeepFocus: true
  }), /*#__PURE__*/_react["default"].createElement(_dateInput["default"], (0, _extends2["default"])({
    ref: inputRef,
    id: id,
    isDisabled: isDisabled,
    isReadOnly: isReadOnly,
    date: date,
    dateFormat: dateFormat,
    humanFormat: humanFormat,
    onChange: onChange,
    onChangePossibleDate: handlePossibleDateChange,
    onClick: showCalendar,
    onError: onError,
    beforeConfirmation: hideCalendar,
    denyConfirmation: function denyConfirmation() {
      return (0, _isElementContainsFocus["default"])(calendarRef.current);
    }
  }, extendedInputProps, {
    hasError: hasErrorValue
  })), /*#__PURE__*/_react["default"].createElement(_popover["default"].Content, null, /*#__PURE__*/_react["default"].createElement(sc.CalendarPopover, {
    "data-pka-anchor": "datepicker.calendar",
    ref: calendarRef
  }, shouldShowCalendar ? /*#__PURE__*/_react["default"].createElement(_SingleDateCalendar["default"], {
    date: date,
    onSelect: handleSelect,
    possibleDate: debouncedPossibleDate,
    resetPossibleDate: handleResetPossibleDate
  }) : null)));
}

DatePicker.displayName = "DatePicker";
DatePicker.propTypes = propTypes;
DatePicker.defaultProps = defaultProps;
DatePicker.Input = _DateInputPropsCollector["default"];
DatePicker.Popover = _DatePickerPopoverPropsCollector["default"];
var _default = DatePicker;
exports["default"] = _default;
//# sourceMappingURL=DatePicker.js.map